import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import {
  BaseAntModules,
  SafePipe,
  TokenService,
  FlSideComponent,
  ErrorHandlerService,
  RequestContextService,
  AppTitleStrategy,
} from '@common';
import { QuestionRootService } from '@shared/question/question-root.service';
import { TrustedLoginInterceptor } from '@shared/interceptors/trusted-login.interceptor';
import { NzTagComponent } from 'ng-zorro-antd/tag';

import { AppComponent } from './app.component';
import { AppRouteModule } from './app-routing.module';
import { MessagePanelComponent } from './message/message-panel.component';
import { provideHttpClient, withInterceptorsFromDi, withXhr, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SiteHomeDirective } from './non-layout/home/site-home.directive';
import { NZ_I18N, zh_CN } from 'ng-zorro-antd/i18n';
import { SharedModule } from '@shared/shared.module';
import { G2ChartModule } from './g2-angular/g2-angular.module';
import { AuthService } from '@shared/service/auth.service';
import { SiteService } from '@shared/service/site.service';
import { NavHeaderDirective } from './global/nav-header.directive';
import { AnonymousGuardGuard } from '@shared/guard/anonymous-guard.guard';
import { AuthModule } from './auth/auth.module';
import { FormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { BaseLayoutComponent } from './base-layout/base-layout.component';
import { BaseLayoutService } from '@app/global/services/base-layout.service';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzPopoverDirective } from 'ng-zorro-antd/popover';
import { ImageTransformPipe } from '@shared/pipes/imageTransform.pipe';
import { DraggableSnapDirective } from '@common';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { TitleStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';
import { zhCN } from 'date-fns/locale';

registerLocaleData(zh);

@NgModule({
  declarations: [AppComponent, SiteHomeDirective, NavHeaderDirective, BaseLayoutComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRouteModule,
    SharedModule,
    AuthModule,
    FormsModule,
    G2ChartModule.forRoot(),
    BaseAntModules,
    NzLayoutModule,
    NzSliderModule,
    NzMenuModule,
    NzAffixModule,
    NzDropdownModule,
    NzTagComponent,
    NzAlertComponent,
    SafePipe,
    NzButtonComponent,
    NzPopoverDirective,
    FlSideComponent,
    ImageTransformPipe,
    DraggableSnapDirective,
    MessagePanelComponent,
  ],
  providers: [
    AuthService,
    SiteService,
    BaseLayoutService,
    RequestContextService,
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService,
    },
    AnonymousGuardGuard,
    TokenService,
    { provide: NZ_I18N, useValue: zh_CN },
    QuestionRootService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    // 临时登录被后端 403 拦截时统一拉起安全验证弹窗（18729）
    { provide: HTTP_INTERCEPTORS, useClass: TrustedLoginInterceptor, multi: true },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: {
        usePopover: false,
      },
    },
    // 显式指定中文 locale 与周一起始，保持升级前日期组件的既有行为（无参会退回 enUS + 周日起始）
    provideNzDateFnsAdapter({ locale: zhCN, firstDayOfWeek: 1 }),
  ],
})
export class AppModule {}
